import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { ApiCreateDealer, ApiGetDealerList, ApiUpdateDelear } from '../../../Core/Apicall';
import { useNavigate, useParams } from 'react-router-dom';
import { Dealer } from '../../../types/Dealer';
import { useSelector } from 'react-redux';
import { RootState } from '../../../Redux/store';



export const fullSchema = Yup.object({
    firstName: Yup.string()
        .trim()
        .required("First name is required"),

    lastName: Yup.string()
        .trim()
        .required("Last name is required"),

    companyName: Yup.string()
        .trim()
        .required("Company name is required"),
    gstNumber: Yup.string()
        .matches(
            /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
            "Enter a valid GST number"
        )
        .required("GST number is required"),

    panNumber: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Enter a valid PAN number")
        .required("PAN number is required"),

    address: Yup.string()
        .trim()
        .required("Address is required"),

    city: Yup.string()
        .trim()
        .required("City is required"),

    state: Yup.string()
        .trim()
        .required("State is required"),

    country: Yup.string()
        .trim()
        .required("Country is required"),

    postalCode: Yup.string()
        .matches(/^[0-9]{6}$/, "Enter a valid postal code")
        .required("Postal code is required"),

    email: Yup.string()
        .email("Enter a valid email")
        .required("Email is required"),

    mobile: Yup.string()
        .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
        .required("Mobile number is required"),
})
function CreateDealer() {
    const navigate = useNavigate()
    const { subClientId } = useParams()
    const [dealerdetails, setDealerDeatails] = useState<Dealer | null>(null)
    const { userDetails } = useSelector((state: RootState) => state.global)
    const formik = useFormik({
        initialValues: {
            "companyName": dealerdetails?.companyName || "",
            "email": dealerdetails?.email || "",
            "mobile": dealerdetails?.mobile || "",
            "gstNumber": dealerdetails?.gstNumber || "",
            "panNumber": dealerdetails?.panNumber || "",
            "website": dealerdetails?.website || "",
            "address": dealerdetails?.address || "",
            "city": dealerdetails?.city || "",
            "state": dealerdetails?.state || "",
            "country": dealerdetails?.country || "",
            "postalCode": dealerdetails?.postalCode || "",
            "firstName": dealerdetails?.subClientAdmin?.firstName || "",
            "lastName": dealerdetails?.subClientAdmin?.lastName || ""
        },
        enableReinitialize: true,
        validationSchema: fullSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    "companyName": values.companyName,
                    "contactPerson": `${values.firstName} ${values.lastName}`,
                    "email": values.email,
                    "mobile": values.mobile,
                    "gstNumber": values.gstNumber,
                    "panNumber": values.panNumber,
                    "website": values.website,
                    "address": values.address,
                    "city": values.city,
                    "state": values.state,
                    "country": values.country,
                    "postalCode": values.postalCode,
                    "firstName": values.firstName,
                    "lastName": values.lastName
                }
                const res = subClientId ? await ApiUpdateDelear(`?subClientId=${subClientId}`,data) : await ApiCreateDealer(data) 
                if (res?.status) {
                    navigate(-1)
                }
            } catch (error: any) {
                toast.error(error?.message || "Something went wrong")
            }
            console.log(values);
        },
    });

    const getDealerDeatails = async () => {
        setDealerDeatails(null)
        try {
            const data = `?subClientId=${subClientId}&clientId=${userDetails?.clientId}`
            const res = await ApiGetDealerList(data)
            if (res?.status || res?.success) {
                setDealerDeatails(res?.data[0])
            }

        } catch (error: any) {
            toast.error(error?.message || "Something went wrong")
        }
    }
    useEffect(() => {
        subClientId && getDealerDeatails()
    }, [subClientId])

    return (
        <Box className='p-3 d-flex flex-column h-100'>
            <Typography variant='h5' className='fw-bold' sx={{ lineHeight: 'normal' }}>{subClientId ? "Update":"Create"}  Dealers</Typography>
            <Box className='d-flex flex-column mt-3' style={{ flex: 1 }}>
                <Box sx={{ flex: 1 }}>
                    <Grid className='form-text-field' container spacing={1.5}>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Company Name</Typography>
                            <TextField
                                name='companyName'
                                fullWidth
                                placeholder='Enter company name'
                                value={formik.values.companyName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.companyName &&
                                    Boolean(formik.errors.companyName)
                                }
                                helperText={
                                    formik.touched.companyName
                                        ? (formik.errors.companyName as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Email</Typography>
                            <TextField
                                name='email'
                                fullWidth
                                type='email'
                                placeholder='Enter email address'
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.email &&
                                    Boolean(formik.errors.email)
                                }
                                helperText={
                                    formik.touched.email
                                        ? (formik.errors.email as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Phone</Typography>
                            <TextField
                                name='mobile'
                                fullWidth
                                placeholder='Enter phone number'
                                value={formik.values.mobile}
                                // onChange={formik.handleChange}
                                onChange={(e) => {
                                    const numbersOnly = e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 10);

                                    formik.setFieldValue("mobile", numbersOnly);
                                }}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.mobile &&
                                    Boolean(formik.errors.mobile)
                                }
                                helperText={
                                    formik.touched.mobile
                                        ? (formik.errors.mobile as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>First Name</Typography>
                            <TextField
                                name='firstName'
                                fullWidth
                                placeholder='Enter first name'
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                                helperText={
                                    formik.touched.firstName
                                        ? (formik.errors.firstName as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Last Name</Typography>
                            <TextField
                                name='lastName'
                                fullWidth
                                placeholder='Enter last name'
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                                helperText={
                                    formik.touched.lastName
                                        ? (formik.errors.lastName as string)
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Website</Typography>
                            <TextField
                                name='website'
                                fullWidth
                                placeholder='Enter website URL'
                                value={formik.values.website}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.website &&
                                    Boolean(formik.errors.website)
                                }
                                helperText={
                                    formik.touched.website
                                        ? (formik.errors.website as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>GST Number</Typography>
                            <TextField
                                name='gstNumber'
                                fullWidth
                                placeholder='Enter gst number'
                                value={formik.values.gstNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.gstNumber &&
                                    Boolean(formik.errors.gstNumber)
                                }
                                helperText={
                                    formik.touched.gstNumber
                                        ? (formik.errors.gstNumber as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 4 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>PAN Number</Typography>
                            <TextField
                                name='panNumber'
                                fullWidth
                                placeholder='Enter pan number'
                                value={formik.values.panNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.panNumber &&
                                    Boolean(formik.errors.panNumber)
                                }
                                helperText={
                                    formik.touched.panNumber
                                        ? (formik.errors.panNumber as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Address Line</Typography>
                            <TextField
                                fullWidth
                                name='address'
                                placeholder='Enter address'
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.address &&
                                    Boolean(formik.errors.address)
                                }
                                helperText={
                                    formik.touched.address
                                        ? (formik.errors.address as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>City</Typography>
                            <TextField
                                name='city'
                                fullWidth
                                placeholder='Enter City'
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.city &&
                                    Boolean(formik.errors.city)
                                }
                                helperText={
                                    formik.touched.city
                                        ? (formik.errors.city as string)
                                        : ""
                                }
                            />
                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>State</Typography>
                            <TextField
                                fullWidth
                                name='state'
                                placeholder='Enter State'
                                value={formik.values.state}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.state &&
                                    Boolean(formik.errors.state)
                                }
                                helperText={
                                    formik.touched.state
                                        ? (formik.errors.state as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Country</Typography>
                            <TextField
                                fullWidth
                                name='country'
                                placeholder='Enter country'
                                value={formik.values.country}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.country &&
                                    Boolean(formik.errors.country)
                                }
                                helperText={
                                    formik.touched.country
                                        ? (formik.errors.country as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6, lg: 3 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Postal Code</Typography>
                            <TextField
                                fullWidth
                                name='postalCode'
                                placeholder='Enter Postal Code'
                                value={formik.values.postalCode}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.postalCode &&
                                    Boolean(formik.errors.postalCode)
                                }
                                helperText={
                                    formik.touched.postalCode
                                        ? (formik.errors.postalCode as string)
                                        : ""
                                }
                            />

                        </Grid>
                        {/* <Grid size={{ xs: 12, md: 6 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Registration Number</Typography>
                    <TextField
                        name='registrationNumber'
                        fullWidth
                        placeholder='Enter registartion number'
                        value={formik.values.registrationNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.registrationNumber &&
                            Boolean(formik.errors.registrationNumber)
                        }
                        helperText={
                            formik.touched.registrationNumber
                                ? (formik.errors.registrationNumber as string)
                                : ""
                        }
                    />
                </Grid> */}
                    </Grid>
                </Box>
                <Box className='d-flex justify-content-end mt-3'>
                    <Button className='btn-main px-4 py-2' onClick={() => formik.handleSubmit()}>{subClientId ? "Update" :"Create"}</Button>
                </Box>
            </Box>
        </Box>
    )
}

export default CreateDealer
